'use strict';

function BigTarget() {

    /********************************/
    // Init big target
    /********************************/
    this.initBigTarget = function () {
        // Use bigTarget to make navbox clickable.
        if($('navbox-title').length){
            if($.fn.bigTarget){
                $('.navbox-title a').bigTarget({
                    clickZone: 'div:eq(1)' // jQuery parent selector
                });
            }
        }
    };
}
